import * as React from "react";
import { Button } from "@react-email/button";
import {
  Img,
  Heading,
  Row,
  Section,
  Column,
  Container,
  Link,
} from "@react-email/components";
import { Text } from "@react-email/text";
import Layout from "../components/Layout";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Markdown } from "@react-email/markdown";

export const name = "RSVPConfirmation";
export const subject = "{{event_name}} RSVP";

export function template({
  event_name,
  event_url,
  organization_name,
  wallet_url,
  event_description,
  event_image,
  cdn_url,
}: {
  event_name: string;
  event_url: string;
  wallet_url: string;
  organization_name: string;
  event_description: string;
  event_image: string;
  organization_image: string;
  cdn_url: string;
}) {
  return (
    <Layout language="en" title={`${event_name} RSVP`}>
      <Header src={`${cdn_url}/system/kyd-logo-email.png`} />
      <Container>
        <Heading as="h1" style={title}>
          Your RSVP has been confirmed.
        </Heading>
        <Link href={event_url}>
          <Img
            width={"100%"}
            style={{ marginTop: "8px", borderRadius: "4px" }}
            src={event_image}
          />
        </Link>
        <Button
          href={wallet_url}
          style={{
            backgroundColor: "black",
            borderRadius: "45px",
            fontWeight: "bold",
            letterSpacing: "2px",
            borderWidth: "3px",
            padding: "15px 40px",
            color: "white",
            fontSize: "16px",
            margin: "16px auto",
          }}
        >
          VIEW RSVP
        </Button>
        <Heading
          as="h2"
          style={{ fontWeight: "bold", fontSize: "18px", color: "black" }}
        >
          Friendly Reminder - {event_name} RSVP does not guarantee entry.
        </Heading>
      </Container>
      <Section width={"100%"}>
        <Row>
          <Heading as="h2" style={subtitle}>
            Event Details
          </Heading>
        </Row>
        <Row>
          <Markdown >{event_description}</Markdown>
        </Row>
        <Row style={{ marginTop: "15px" }}>
          <Column>
            <Text
              style={{ fontSize: "24px", lineHeight: "28px", color: "black" }}
            >
              Event brought to you by {organization_name}
            </Text>
          </Column>
        </Row>
      </Section>
      <Footer cdn_url={cdn_url} />
    </Layout>
  );
}

const bodyText = {
  fontSize: "14px",
  lineHeight: "22px",
  color: "black",
};

const title = {
  fontSize: "48px",
  lineHeight: "40px",
  marginBottom: "8px",
  color: "black",
};

const subtitle = {
  ...title,
  fontSize: "18px",
  color: "black",
};

template.PreviewProps = {
  event_name: "Test event",
  event_url: "/static/coachella.jpg",
  organization_name: "Organizers Inc.",
  wallet_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/wallet",
  event_description:
    "This is a really cool event that you should join. It also sends emails to people 🤣",
  cdn_url: "",
  event_image: "",
};

export default template;
